<div mat-dialog-title class="ds">
  <span>{{appStrings.accounts_search}}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="content ds" [ngClass]="{ 'mobile': isMobile, 'desktop': !isMobile }">
  <form [formGroup]="searchForm" (keyup.enter)="searchText()">
    <div class="search-form-content">
      @if (!isAccountManager) {
        <div class="field-group">
          <ds-autocomplete id="accountManagerField" class="fill-width no-subscript"
            [options]="accountManagerOptions" [label]="appStrings.quoteSearch_accountManager"
            label_orientation="horizontal-label" [control]="searchForm.controls.accountManager"
          ></ds-autocomplete>
        </div>
      }

      <div class="field-group">
        <ds-textfield id="customerNameField" class="fill-width no-subscript"
          [label]="appStrings.label_customerName" label_orientation="horizontal-label"
          [control]="searchForm.controls.Name" [isDisabled]="searchForm.controls.Name.disabled"
        ></ds-textfield>
      </div>

      <div class="field-group">
        <ds-textfield id="bpNumberField" class="fill-width no-subscript"
          [label]="appStrings.label_bpNumber" label_orientation="horizontal-label"
          [control]="searchForm.controls.BPNumber" [isDisabled]="searchForm.controls.BPNumber.disabled"
        ></ds-textfield>
      </div>

      <div class="field-group">
        <ds-textfield id="contactField" class="fill-width no-subscript"
          [label]="appStrings.label_contact" label_orientation="horizontal-label"
          [control]="searchForm.controls.Contact" [isDisabled]="searchForm.controls.Contact.disabled"
        ></ds-textfield>
      </div>

      <div class="field-group">
        <ds-textfield id="childName1Field" class="fill-width no-subscript"
          [label]="appStrings.label_childName" label_orientation="horizontal-label"
          [control]="searchForm.controls.ChildName1" [isDisabled]="searchForm.controls.ChildName1.disabled"
        ></ds-textfield>
      </div>

      <div class="field-group">
        <ds-textfield id="priceMatrixField" class="fill-width no-subscript"
          [label]="appStrings.accounts_priceMatrix" label_orientation="horizontal-label"
          [control]="searchForm.controls.priceMatrix"
        ></ds-textfield>
      </div>

      <div class="field-group">
        <ds-textfield id="cityField" class="fill-width no-subscript"
          [label]="appStrings.contacts_city" label_orientation="horizontal-label"
          [control]="searchForm.controls.city"
        ></ds-textfield>
      </div>

      @if (displayStateOrProvinceField) {
        <div class="field-group">
          <ds-select id="stateSelect" class="fill-width no-subscript"
            [label]="stateOrProvince" label_orientation="horizontal-label"
            [dropOptions]="stateOptions" [control]="searchForm.controls.state"
          ></ds-select>
        </div>
      }

      @if (displayPostalCodeField) {
        <div class="field-group">
          <ds-textfield id="postalCodeField" class="fill-width no-subscript"
            [label]="appStrings.accounts_postalCode" label_orientation="horizontal-label"
            [control]="searchForm.controls.postalCode"
          ></ds-textfield>
        </div>
      }

      @if (displayCountryField) {
        <div class="field-group">
          <ds-select id="countrySelect" class="fill-width no-subscript"
            [label]="appStrings.contacts_country" label_orientation="horizontal-label"
            [dropOptions]="countryOptions" [control]="searchForm.controls.country"
          ></ds-select>
        </div>
      }

      @if (isOnline) {
        <div class="field-group">
          <ds-select id="showForSelect" class="fill-width no-subscript"
            [label]="appStrings.accounts_showFor" label_orientation="horizontal-label"
            [dropOptions]="intervalOptions" [control]="searchForm.controls.filterByInterval"
          ></ds-select>
        </div>
      }

      <div class="field-group">
        <ds-select id="lnStatusSelect" class="fill-width no-subscript"
          [label]="appStrings.accounts_lnStatus" label_orientation="horizontal-label"
          [dropOptions]="lnStatusOptions" [control]="searchForm.controls.lnStatus"
        ></ds-select>
      </div>

      <div class="checkbox-group">
        <ds-checkbox id="accountsCheckbox"
          [label]="appStrings.accounts_showAccounts" [control]="searchForm.controls.accounts"
        ></ds-checkbox>
        <ds-checkbox id="leadsCheckbox"
          [label]="appStrings.accounts_showLeads" [control]="searchForm.controls.leads"
        ></ds-checkbox>
        <ds-checkbox id="deliveryCheckbox"
          [label]="appStrings.accounts_showLeadsNewDelivery" [control]="searchForm.controls.delivery"
        ></ds-checkbox>
      </div>
    </div>
  </form>
</div>

<div mat-dialog-actions align="end" class="ds advanced-search-actions">
  <div class="dialog-btn-wrapper">
    <ds-button id="closeDialogButton" variant="label-only"
      size="medium" type="tertiary" (onClick)="dialogRef.close()"
      [label]="appStrings.button_close"
    ></ds-button>
    <ds-button id="clearFiltersButton"
      variant="label-only" size="medium"
      type="secondary" (onClick)="clearAllFilters()"
      [label]="appStrings.accounts_clearFilters" [isDisabled]="!formHasValue"
    ></ds-button>
    <ds-button id="searchButton" variant="label-only"
      size="medium" type="primary" (onClick)="searchText()"
      [label]="appStrings.accounts_search"
    ></ds-button>
  </div>
</div>